import { mediaData } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            热门视频
          </h2>
          <p className="text-foreground-500 text-sm">吃瓜爆料视频精选</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer hover:shadow-lg transition-shadow duration-300"
            >
              <div className="relative">
                <div className="w-full aspect-video overflow-hidden">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-500 text-background-50 text-xs font-bold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center cursor-pointer hover:bg-white transition-colors">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-800 font-bold text-sm leading-snug line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-foreground-400 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}